module.exports = __webpack_public_path__ + "img/Xgrow-9-pt.270b7ff3.png";